import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import find from 'lodash/find'
import matches from 'lodash/matches'
import isNil from 'lodash/isNil'
import Button from '@vtex/styleguide/lib/Button'

import NumberInput from '@/checkout-instore-legacy/components/Commons/NumberInput'
import * as PaymentUtils from '@/checkout-instore-legacy/utils/PaymentUtils'
import PaymentItem from '@/checkout-instore-legacy/components/Commons/PaymentItem'
import Price from '@/checkout-instore-legacy/components/Commons/Price'
import { buildChildId } from '@/checkout-instore-legacy/utils/TestUtils'

export default class EditPaymentForm extends React.Component {
  constructor(props) {
    super(props)
    const value = PaymentUtils.getPaymentValue(props.payment)
    this.state = {
      value: value > 0 ? value : 0,
      modifiedValue: false,
    }
  }

  handleValueChange(newValue) {
    const { maxValue } = this.props
    const value =
      typeof maxValue === 'number' && newValue > maxValue ? maxValue : newValue
    this.setState({ value })
  }

  handleClick(callback) {
    callback(this.state.value, this.props.payment)
  }

  canSubmit() {
    return this.state.value > 0
  }

  getValidationMessage() {
    if (!isNil(this.props.remainingValue)) {
      const paymentValue = PaymentUtils.getPaymentValue(this.props.payment)
      let remainingValue = this.props.remainingValue + paymentValue
      remainingValue -= this.state.value

      if (remainingValue < 0) {
        return (
          <div key="0" className="tc light-red mb5 f4-ns">
            <FormattedMessage id="addPaymentFormValueGreaterThanTotalValidation" />{' '}
            <span className="fw4">
              <Price value={-remainingValue} />
            </span>
          </div>
        )
      }
    }
  }

  renderValueErrorMessage() {
    return this.state.value === 0 && this.state.modifiedValue ? (
      <FormattedMessage
        id="addPaymentFormValueGreaterThanZero"
        values={{
          zero: (
            <strong>
              <FormattedMessage id="zero" />
            </strong>
          ),
        }}
      />
    ) : null
  }

  render() {
    const { payment, paymentSystems } = this.props
    const paymentSystem =
      find(
        paymentSystems,
        matches({
          stringId: payment && payment.paymentSystem,
        })
      ) || {}

    return (
      <div className="EditPaymentForm component">
        <PaymentItem
          className="bb b--black-10"
          id={buildChildId('payment', this.props.id)}
          paymentName={paymentSystem.name}
          groupName={paymentSystem.groupName}
          value={PaymentUtils.getPaymentValue(payment)}
        />

        <form
          className="tc"
          onSubmit={(e) => {
            e.preventDefault()
            this.props.onSubmit(this.state.value)
          }}
        >
          <div className="pt2 pb4 tl mt7">
            <NumberInput
              id={buildChildId('value', this.props.id)}
              labelId="addPaymentFormValue"
              className="f4 f3-ns tl"
              value={this.state.value}
              onChange={(v) => this.handleValueChange(v)}
              onBlur={() => this.setState({ modifiedValue: true })}
              onFocus={() => this.setState({ modifiedValue: false })}
              errorMessage={this.renderValueErrorMessage()}
            />
          </div>

          {this.getValidationMessage()}

          <div className="flex justify-end mt7">
            <div className="mr3">
              <Button
                id={buildChildId('button-delete', this.props.id)}
                type="button"
                onClick={(e) => {
                  e.preventDefault()
                  this.props.onDelete()
                }}
                variation="danger"
                size="large"
              >
                <FormattedMessage id="editPaymentFormRemove" />
              </Button>
            </div>
            <Button
              id={buildChildId('button-confirm', this.props.id)}
              type="submit"
              variation="primary"
              size="large"
              disabled={!this.canSubmit()}
            >
              <FormattedMessage id="editPaymentFormUpdate" />
            </Button>
          </div>
        </form>
      </div>
    )
  }
}

EditPaymentForm.propTypes = {
  id: PropTypes.string,
  paymentSystems: PropTypes.array,
  payment: PropTypes.any,
  remainingValue: PropTypes.number,
  maxValue: PropTypes.number,
  onSubmit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}
